// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-radio {
  font-family: AppFont, sans-serif !important;
}

ion-item {
  --border-width: 1px;
  --background: transparent;
  --border-color: #E5E5E5;
  font-family: AppFont, sans-serif !important;
}

ion-select {
  width: 100%;
  text-align: left;
  background: transparent;
}

.no-line {
  --border-width: 0px !important;
  border-bottom: 0px;
  --background: transparent;
}

ion-label {
  padding: 0px 2px;
  background: #fff;
}

.title {
  font-family: var(--font-tusker);
  font-size: 26px;
  color: var(--ion-color-secondary);
  text-transform: capitalize;
}

.wrapper {
  padding: 20px;
}

.privacy {
  font-size: 12px;
  color: var(--ion-color-black);
  font-family: AppFont, san-serif;
}
.privacy ion-button {
  padding: 0px;
  color: var(--ion-color-primary);
  text-transform: capitalize;
}

.privacy-btn {
  margin-left: 1px;
}
@media (min-width: 991px) {
  .privacy-btn {
    margin-left: 5px;
  }
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
  font-family: AppFont, sans-serif !important;
}

.stacked {
  position: relative;
  top: 7px;
  left: 10px;
  z-index: 2;
}

.terms {
  min-width: 360px;
  margin-left: 0px;
}
.terms ion-button {
  font-family: AppFont, san-serif;
}

ion-checkbox {
  margin-left: 0px;
}

ion-footer {
  --background: transparent;
}
ion-footer ion-button {
  font-family: AppFont, san-serif;
}
@media (min-width: 991px) {
  ion-footer ion-button {
    --background: url('button_background_orange.png') no-repeat center center/ 100% 100% !important;
  }
}

.two_blocks {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.two_blocks div {
  width: 48%;
}

.margin-top {
  margin-top: 10px;
}

.privacy span {
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-subtitle);
  font-size: 12px;
}
.privacy .link {
  text-decoration: underline;
  color: var(--ion-color-tertiary);
}

.privacy span {
  color: var(--ion-color-subtitle);
  font-size: 12px;
}
.privacy .link {
  text-decoration: underline;
  color: var(--ion-color-tertiary);
  position: relative;
  z-index: 100;
}

.open_privacy {
  z-index: 100 !important;
  position: relative;
  color: var(--ion-color-tertiary);
}

.custom_phone .item_input,
.custom_phone .item_select {
  --padding-start: 8px !important;
}
.custom_phone .item_select {
  --ripple-color: transparent;
  --background-hover: none;
  border: none !important;
  --border-width: 0px !important;
  --highlight-background: none;
}
.custom_phone .item_select ion-img {
  height: 16px;
  width: 34px;
  margin-right: 5px;
}
.custom_phone .item_select ion-select {
  border-right: 1px solid #e5e5e5;
  font-family: AppFont, sans-serif;
  background: transparent;
}
.custom_phone .item_select ion-select::part(native) {
  border: none;
}

ion-select {
  font-family: AppFont, sans-serif;
}

.transparent_back {
  width: 100%;
}
.transparent_back ion-label {
  background: transparent;
}

.more_info {
  color: #585858;
  font-family: AppFont, san-serif;
  font-size: 12px;
  padding-left: 5px;
  margin: 0px;
  text-transform: inherit;
}

.padding-text {
  padding: 1px;
}

ion-select-option {
  font-family: AppFont, sans-serif !important;
}

.align-start {
  align-items: flex-start;
}
.align-start ion-checkbox {
  margin-top: 14px;
}

ion-footer {
  box-shadow: none;
  --box-shadow: none ;
}

ion-input input::-webkit-outer-spin-button,
ion-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-up/sign-up.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;;AAIA;EACE,QAAA;EACA,kBAAA;AADF;;AAGA;EACE,2CAAA;AAAF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2CAAA;AACF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;AAEF;;AAAA;EACE,8BAAA;EACA,kBAAA;EACA,yBAAA;AAGF;;AADA;EACE,gBAAA;EACA,gBAAA;AAIF;;AADA;EACE,+BAAA;EACA,eAAA;EACA,iCAAA;EACA,0BAAA;AAIF;;AAFA;EACE,aAAA;AAKF;;AAHA;EACE,eAAA;EACA,6BAAA;EACA,+BAAA;AAMF;AALE;EACE,YAAA;EACA,+BAAA;EACA,0BAAA;AAOJ;;AAHA;EAIE,gBAAA;AAGF;AC5DE;EDqDF;IAEI,gBAAA;EASF;AACF;;AALA;EACE,eAAA;EACA,mBAAA;AAQF;;AALA;EACE,oBAAA;EACA,gBAAA;EACA,2CAAA;AAQF;;AAJA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AAOF;;AAJA;EACE,gBAAA;EACA,gBAAA;AAOF;AANE;EACE,+BAAA;AAQJ;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;AANE;EACE,+BAAA;AAQJ;ACtGE;ED6FA;IAGI,+FAAA;EAUJ;AACF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AASF;AARE;EACE,UAAA;AAUJ;;AAPA;EACE,gBAAA;AAUF;;AAPE;EACE,oCAAA;EACA,gCAAA;EACA,eAAA;AAUJ;AARE;EACE,0BAAA;EACA,gCAAA;AAUJ;;AALE;EACE,gCAAA;EACA,eAAA;AAQJ;AANE;EACE,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AAQJ;;AALA;EACE,uBAAA;EACA,kBAAA;EACA,gCAAA;AAQF;;AAHE;;EAEE,+BAAA;AAMJ;AAJE;EACE,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,4BAAA;AAMJ;AAJI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAMN;AAHI;EACE,+BAAA;EAEA,gCAAA;EACA,uBAAA;AAIN;AAFM;EACE,YAAA;AAIR;;AACA;EACE,gCAAA;AAEF;;AAAA;EAIE,WAAA;AAAF;AAHE;EACE,uBAAA;AAKJ;;AADA;EACE,cAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;AAIF;;AAFA;EACE,YAAA;AAKF;;AAHA;EACE,2CAAA;AAMF;;AAHA;EAEE,uBAAA;AAKF;AAJE;EACE,gBAAA;AAMJ;;AAHA;EACE,gBAAA;EACA,mBAAA;AAMF;;AADE;;EAEE,wBAAA;EACA,SAAA;AAIJ","sourcesContent":["@import \"../../../theme/mixins\";\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n}\nion-radio {\n  font-family: AppFont, sans-serif !important;\n}\nion-item {\n  --border-width: 1px;\n  --background: transparent;\n  --border-color: #E5E5E5;\n  font-family: AppFont, sans-serif !important;\n}\nion-select {\n  width: 100%;\n  text-align: left;\n  background: transparent;\n}\n.no-line {\n  --border-width: 0px !important;\n  border-bottom: 0px;\n  --background: transparent;\n}\nion-label {\n  padding: 0px 2px;\n  background: #fff;\n}\n\n.title {\n  font-family: var(--font-tusker);\n  font-size: 26px;\n  color: var(--ion-color-secondary);\n  text-transform: capitalize;\n}\n.wrapper {\n  padding: 20px;\n}\n.privacy {\n  font-size: 12px;\n  color: var(--ion-color-black);\n  font-family: AppFont, san-serif;\n  ion-button {\n    padding: 0px;\n    color: var(--ion-color-primary);\n    text-transform: capitalize;\n   \n  }\n}\n.privacy-btn {\n  @include desktop {\n    margin-left: 5px;\n  }\n  margin-left: 1px;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-item {\n  --border-radius: 5px;\n  margin-bottom: 0;\n  font-family: AppFont, sans-serif !important;\n\n}\n\n.stacked {\n  position: relative;\n  top: 7px;\n  left: 10px;\n  z-index: 2;\n}\n\n.terms {\n  min-width: 360px;\n  margin-left: 0px;\n  ion-button {\n    font-family: AppFont, san-serif;\n  }\n}\n\nion-checkbox {\n  margin-left: 0px;\n}\n\nion-footer {\n  --background: transparent;\n  ion-button {\n    font-family: AppFont, san-serif;\n     @include desktop {\n      --background: url(../../../assets/tabilo/button_background_orange.png) no-repeat center center/ 100% 100% !important;\n  \n    }\n  }\n}\n.two_blocks {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  div {\n    width: 48%;\n  }\n}\n.margin-top {\n  margin-top: 10px;\n}\n.privacy {\n  span {\n    font-family: AppFontBold, sans-serif;\n    color: var(--ion-color-subtitle);\n    font-size: 12px;\n  }\n  .link {\n    text-decoration: underline;\n    color: var(--ion-color-tertiary);\n  }\n}\n\n.privacy {\n  span {\n    color: var(--ion-color-subtitle);\n    font-size: 12px;\n  }\n  .link {\n    text-decoration: underline;\n    color: var(--ion-color-tertiary);\n    position: relative;\n    z-index: 100;\n  }\n}\n.open_privacy {\n  z-index: 100 !important;\n  position: relative;\n  color: var(--ion-color-tertiary);\n\n }\n\n.custom_phone {\n  .item_input,\n  .item_select {\n    --padding-start: 8px !important;\n  }\n  .item_select {\n    --ripple-color: transparent;\n    --background-hover: none;\n    border: none !important;\n    --border-width: 0px !important;\n    --highlight-background: none;\n\n    ion-img {\n      height: 16px;\n      width: 34px;\n      margin-right: 5px;\n    }\n\n    ion-select {\n      border-right: 1px solid #e5e5e5;\n      // --border-color: transparent;\n      font-family: AppFont, sans-serif;\n      background: transparent;\n\n      &::part(native) {\n        border: none;\n      }\n    }\n  }\n}\nion-select {\n  font-family: AppFont, sans-serif;\n}\n.transparent_back {\n  ion-label {\n    background: transparent;\n  }\n  width: 100%;\n}\n.more_info {\n  color: #585858;\n  font-family: AppFont, san-serif;\n  font-size: 12px;\n  padding-left: 5px;\n  margin: 0px;\n  text-transform: inherit;\n}\n.padding-text {\n  padding: 1px;\n}\nion-select-option {\n  font-family: AppFont, sans-serif !important;\n}\n\n.align-start {\n  // display: flex;\n  align-items: flex-start;\n  ion-checkbox {\n    margin-top: 14px;\n  }\n}\nion-footer {\n  box-shadow: none;\n  --box-shadow: none\n}\n\n\nion-input {\n  input::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
